module.exports = __webpack_public_path__ + "img/148.a08009f3.jpg";